import { defaultAppConfig } from './default-app-config';

type AppEnvironment = 'stage' | 'dev';
interface IAppConstants { APP_ENVIRONMENT: AppEnvironment };

export const AppConstants: IAppConstants = { APP_ENVIRONMENT: 'stage' };

export enum FeatureAppNames {
  MODELS_CAROUSEL = 'models-carousel',
  DEFAULT = 'default',
};

export const appsUMD = {
  [FeatureAppNames.MODELS_CAROUSEL]: '/assets/models-carousel/models-carousel-umd.js',
  [FeatureAppNames.DEFAULT]: defaultAppConfig.appsUMD,
};

export const appsCommonsJS = {
  [FeatureAppNames.MODELS_CAROUSEL]: '/assets/models-carousel/models-carousel-commonjs.js',
  [FeatureAppNames.DEFAULT]: defaultAppConfig.appsCommonsJS,
};